import { render } from "./BannerStack.vue?vue&type=template&id=2f413ece&ts=true"
import script from "./BannerStack.vue?vue&type=script&lang=ts"
export * from "./BannerStack.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__